import React from 'react'
import Input, {InputProps} from './Input'
import { usePlacesWidget } from 'react-google-autocomplete';



type AddressInputProps = InputProps & {
  onPlaceSelected?: (place: any) => void
}

const AddressInput = ({onPlaceSelected, ...rest}: AddressInputProps) => {
  const { ref } = usePlacesWidget<HTMLInputElement>({
    apiKey: process.env.REACT_APP_GOOGLE_PLACES_API_KEY,
    onPlaceSelected: (place) => {
      onPlaceSelected?.(place)
    },
    options: {
      types: [],
      componentRestrictions: { country: ["ca", "us", "ng", "gb"] },
    },
  })

  return (
    <Input ref={ref} {...rest} />
  )
}

export default AddressInput